import { ModeleDeBase } from "./ModeleDeBase";

export interface ITypeClienteleCDS {
  si_typedeclienteleid: string;
  si_ordretri: number;
  si_taxable: boolean;
  si_clientele: string;
  _si_typedeperiodedelocation_value: string;
}

export class TypeClientele extends ModeleDeBase {
  ordretri: number;
  taxable: boolean;
  typePeriodeId: string;
  nomTypeClientele: string;

  constructor(entity: ITypeClienteleCDS) {
    super(entity.si_typedeclienteleid);

    this.ordretri = entity.si_ordretri;
    this.taxable = entity.si_taxable;
    this.typePeriodeId = entity._si_typedeperiodedelocation_value;
    this.nomTypeClientele = entity.si_clientele;
  }

  serialiser(): ITypeClienteleCDS {
    return {
      si_typedeclienteleid: this.id,
      si_ordretri: this.ordretri,
      si_taxable: this.taxable,
      _si_typedeperiodedelocation_value: this.typePeriodeId,
      si_clientele: this.nomTypeClientele,
    };
  }
}
